import sdl from '@jds/react-generated-sdl/JDSFileUploaderPanel';
import type { JDSFileUploaderPanelProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, FileUploaderPanelProps } from '../logic';

const Component = (props: FileUploaderPanelProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'classic',
    expanded = false,
    showDivider = true,
    panelSuffixAriaLabel = 'Toggle Files List',
    _ariaExpanded = props.expanded?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      expanded,
      showDivider,
      panelSuffixAriaLabel,
      _ariaExpanded,
      ...rest
    },
    'JDSFileUploaderPanel',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FileUploaderPanel = withLogic(
  Component
) as React.FC<FileUploaderPanelProps> & { slotName?: string };

FileUploaderPanel.displayName = 'FileUploaderPanel';
FileUploaderPanel.slotName = 'jds_file_uploader_panel';

export { FileUploaderPanel, type JDSFileUploaderPanelProps };
